var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{class:`${_vm.getCssClass()} clear-el-button`,attrs:{"type":"grey"},on:{"click":_vm.onAlternativeClick}},[_vm._v(" "+_vm._s(_vm.alternative.text.filter(t => t.lang === _vm.$i18n.locale)[0].value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }